import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { BaseQueryParamService } from 'base';
import { BaseCustomerEmployeesFiltersEnum } from '../../_enums/base-customer-external-employee-filters.enum';
import { BaseCustomerExternalEmployeeFilterFormInterface } from '../../_interfaces/base-customer-external-employee-filter-form.interface';

@Component({
  selector: 'base-customer-external-employees-search-export',
  templateUrl: './base-customer-external-employee-search-export.component.html',
})
export class BaseCustomerExternalEmployeeSearchExportComponent {
  @Input() filtersForm: FormGroup<BaseCustomerExternalEmployeeFilterFormInterface>;
  @Input({ required: true }) isWorkCouncil: boolean;
  @Output() exportContracts: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() exportAssignmentInfo: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private queryParamsService: BaseQueryParamService, public activatedRoute: ActivatedRoute) {}

  onSearchChange(query: string): void {
    this.filtersForm.controls[BaseCustomerEmployeesFiltersEnum.search].setValue(query);
    this.queryParamsService.filterSubject.next({
      page: this.activatedRoute.snapshot.queryParams.page,
      filters: this.filtersForm.value,
    });
  }

  onExportContracts(): void {
    this.exportContracts.emit(true);
  }

  onExportAssignmentInformation(): void {
    this.exportAssignmentInfo.emit(true);
  }

  handleClick(actionType: string) {
    if (this.isWorkCouncil) {
      return;
    }
    switch (actionType) {
      case 'workingContracts':
        this.onExportContracts();
        break;
      case 'administration.operationalInformation':
        this.onExportAssignmentInformation();
        break;
    }
  }
}
